'use client';

import dynamic from 'next/dynamic';
import { HTMLAttributes } from 'react';

// Dynamic import with SSR disabled for browser-only rendering
const Lottie = dynamic(() => import('lottie-react'), { ssr: false });

interface LottieRenderProps {
    animationPath: string;
    loop?: boolean;
    autoplay?: boolean;
    className?: string;
    style?: React.CSSProperties;
}

const LottieRender = ({ animationPath, loop = true, autoplay = true, className, style }: LottieRenderProps) => {

    // We fetch the JSON on the client to avoid import errors with large files
    const [animationData, setAnimationData] = React.useState(null);
    const [error, setError] = React.useState(false);

    React.useEffect(() => {
        fetch(animationPath)
            .then(res => {
                if (!res.ok) throw new Error("Failed to load");
                return res.json();
            })
            .then(data => setAnimationData(data))
            .catch(err => {
                console.error(`Failed to load Lottie: ${animationPath}`, err);
                setError(true);
            });
    }, [animationPath]);

    if (error) return <div className="text-red-500 text-xs">Animation Error</div>;
    if (!animationData) return <div className="animate-pulse bg-slate-100 rounded-lg w-full h-full" />;

    return (
        <div className={className} style={style}>
            <Lottie
                animationData={animationData}
                loop={loop}
                autoplay={autoplay}
                style={{ width: '100%', height: '100%' }}
            />
        </div>
    );
};

// Needed as this is a Client Component but we need React hooks
import React from 'react';

export default LottieRender;
